import axios from 'axios';
import { ApiError } from '@/src/shared/api/errors';

/**
 * Backend caps page size at 500; the accounts view fetches the max in one
 * call (a user's account count is small) rather than paginating.
 */
export const MAX_PAGE_LIMIT = 500;

/** Normalize an axios failure into the transport-agnostic {@link ApiError}. */
export function toApiError(err: unknown): never {
  if (axios.isAxiosError(err)) {
    throw new ApiError(err.response?.status, err.response?.data);
  }
  throw new ApiError(undefined);
}
